//import SparkMD5 from 'spark-md5'
const SparkMD5 = require('spark-md5');
import store from '../../store/index'
/*module.exports= function(file){
    return new Promise((resolve,reject)=>{
        let fileReader = new FileReader();
        fileReader.readAsBinaryString(file);
        let spark = new SparkMD5();
        fileReader.onload = function(e) {
            spark.appendBinary(e.target.result);
            resolve(spark.end());
            //return spark.end()
        };
    })
};*/
export default {
    getMd5(file){
        return new Promise((resolve,reject)=>{
            let fileReader = new FileReader();
            fileReader.readAsBinaryString(file);
            let spark = new SparkMD5();
            const userId = store.getters.getToken.userId;
            fileReader.onload = function(e) {
                spark.appendBinary(e.target.result);
                let data = {md5:spark.end()+"-"+userId}
                resolve(data);
                //return spark.end()
            };
            fileReader.onerror = function () {
                reject("error")
            };
        })
    },
    getSliceFile(file,index){
        const fileSize = file.size,chunkSize = 5*1024 * 1024,count = Math.ceil(fileSize / chunkSize); // 切成的片数
        let end = (index + 1) > count ? count : index + 1,ifLast = index+1>count,sliceFile = file.slice(index * chunkSize, end * chunkSize);
        return new Promise((resolve,reject)=>{
            if(fileSize){
                resolve({file:sliceFile,size:chunkSize,total:count,ifLast:ifLast});
            }
            else reject("分片失败");
        })
    }
}
